// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard_leaderboard-card__kqIoX {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  border: 1px solid var(--secondary-border-color);
  border-radius: 6px;
  height: min-content;
  overflow-x: hidden;
  overflow: scroll;
}

.leaderboard_leaderboard-header__769rK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
}

.leaderboard_header-ranking__kNBr0 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.leaderboard_team-count__m5bCq {
  font-size: 12px;
  font-weight: 500;
  color: var(--tertiary-text-color);
  padding: 4px 10px;
  background-color: var(--tertiary-background-color);
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/leaderboard/leaderboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0CAA0C;EAC1C,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,kDAAkD;EAClD,kBAAkB;AACpB","sourcesContent":[".leaderboard-card {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  border: 1px solid var(--secondary-border-color);\n  border-radius: 6px;\n  height: min-content;\n  overflow-x: hidden;\n  overflow: scroll;\n}\n\n.leaderboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n}\n\n.header-ranking {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.team-count {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--tertiary-text-color);\n  padding: 4px 10px;\n  background-color: var(--tertiary-background-color);\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leaderboard-card": `leaderboard_leaderboard-card__kqIoX`,
	"leaderboard-header": `leaderboard_leaderboard-header__769rK`,
	"header-ranking": `leaderboard_header-ranking__kNBr0`,
	"team-count": `leaderboard_team-count__m5bCq`
};
export default ___CSS_LOADER_EXPORT___;
